import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private initialized = false;
  private readonly key = environment.posthogKey?.trim();
  private readonly host = environment.posthogHost?.trim();

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    this.initPosthog();
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) {
      return;
    }

    posthog.capture(event, properties);
  }

  identify(userId: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) {
      return;
    }

    posthog.identify(userId, properties);
  }

  reset(): void {
    if (!this.initialized) {
      return;
    }

    posthog.reset();
  }

  private initPosthog(): void {
    if (typeof window === 'undefined' || !this.key || !this.host) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      posthog.init(this.key!, {
        api_host: this.host,
        defaults: '2026-01-30',
        capture_pageview: 'history_change',
      });
    });

    this.initialized = true;

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.capture('page_viewed', {
          path: event.urlAfterRedirects,
        });
      });
  }
}
